
import { useState } from 'react';

export default function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-amber-500 to-amber-600 text-black py-3 px-4 z-[60] shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex-1 text-center">
          <p className="text-sm md:text-base font-bold">
            <i className="ri-scissors-line mr-2"></i>
            Special Offer: <span className="text-lg md:text-xl">20% OFF</span> Your First Visit!
            <i className="ri-scissors-line ml-2"></i>
          </p>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="ml-4 text-black hover:text-white transition-colors cursor-pointer w-6 h-6 flex items-center justify-center"
          aria-label="Close banner"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
      </div>
    </div>
  );
}
